export function transformSelectFormat(selectList, value_name, label_name) {
  const return_select_list = [];
  let message = null;
  let status = null;

  //console.log('Entro a la funcion formateo select');
  try {
    for (let i = 0; i < selectList.length; i++) {
      const aux_obj = {
        value: selectList[i][value_name],
        label: selectList[i][label_name]
      };
      return_select_list.push(aux_obj);
    }
    message = 'success';
    status = 200;
  } catch (error) {
    //console.log(`Error en transformSelectFormat:`, error);
    message = error.message;
    status = 500;
  }

  return {
    message: message,
    status: status,
    data: return_select_list
  };
}

export function transformSelectToList(selectList) {
  const return_select_list = [];
  let message = null;
  let status = null;

  try {
    for (let i = 0; i < selectList.length; i++) {
      return_select_list.push(selectList[i].value);
    }
    message = 'success';
    status = 200;
  } catch (error) {
    //console.log(`Error en transformSelectFormat:`, error);
    message = error.message;
    status = 500;
  }

  return {
    message: message,
    status: status,
    data: return_select_list
  };
}


